import { Component, OnInit } from '@angular/core';
import { PaymentReportService } from '../service/payment-report.service'
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-payments-report',
  templateUrl: './payments-report.component.html',
  styleUrls: ['./payments-report.component.css']
})
export class PaymentsReportComponent implements OnInit {

  arrMonth: any[] = [];
  selectedMonth: any = null;
  customerListDDL: null;
  selectOptionDDL: null;
  cols: any[];
  resultTable: any[] = null;
  msgs: any[] = [];
  reportTypes: string[] = ["רגיל","מקובץ"];
  //reportTypes: string[] = ["רגיל"];
  reportTypeSelected: string = "רגיל";
  showFreezeButton: boolean = false;
  frozenReport: any[] = null;
  isFrozenDataView: boolean = false;
  isGapDataView: boolean = false;
  gapReport: any[] = null;


  constructor(private dataService: PaymentReportService, private router: Router) { }
  ngOnInit() {

    this.dataService.GetMonths().subscribe((result: any) => {
      this.arrMonth = result;
      this.selectedMonth = this.arrMonth[this.arrMonth.length - 1];
      this.typeChange();
      this.monthChanged();
    });

    this.dataService.getCustomerDDL().subscribe((res: any) => {
      this.customerListDDL = res;
    }, (err: HttpErrorResponse) => {
      this.router.navigate(['error-page/', err.error.ExceptionMessage])
    });

    
  }

  monthChanged() {
    this.resultTable = null;
    this.frozenReport = null;
    this.isFrozenDataView = false;
    this.isGapDataView = false;
    if (this.reportTypeSelected == "רגיל" && !this.selectOptionDDL) {
      this.GetFrozenPaymentReport();
    }
  }

  customerChanged() {
    this.resultTable = null;
    this.frozenReport = null;
    this.isFrozenDataView = false;
    this.isGapDataView = false;
    if (this.reportTypeSelected == "רגיל" && !this.selectOptionDDL) {
      this.GetFrozenPaymentReport();
    }
  }

  typeChange() {
    this.resultTable = null;
    if (this.reportTypeSelected == "רגיל" && !this.selectOptionDDL) {
      this.GetFrozenPaymentReport();
    }
  }

  getPaymentReport() {
    this.showFreezeButton = false;
    this.resultTable = null;
    this.isFrozenDataView = false;
    this.isGapDataView = false;
    if (this.reportTypeSelected == "רגיל")
    {
      this.cols = [
        { field: 'CustomerIdentityNumber', header: 'זיהוי מעסיק' },
        { field: 'CustomerName', header: 'מעסיק' },
        { field: 'CHODESH_MASKORET_Formatted', header: 'חודש שכר' },
        { field: 'TypeDescription', header: 'סוג' },
        { field: 'FileEmployeeIdCount', header: 'מספר עובדים' },
        { field: 'BankName', header: 'בנק' },
        { field: 'BankBranchName', header: 'סניף' },
        { field: 'AccountNameBank', header: 'חשבון' },
        //{ field: 'UniqueMISPAR_MEZAHE_RESHUMA', header: 'מספר הפרשות' },
        { field: 'SumTnuotLeOvedBeChodesh', header: 'מספר הפרשות' },
        { field: 'CostCalculatedResult', header: 'סכום לגביה' },
        { field: 'CostCalculatedResultIncludeVAT', header: 'סכום לגביה כולל מע"מ' },
        { field: 'Marker', header: 'סיבת שינוי לסוג חיוב' },
        { field: 'GapForSelectedMonth', header: 'פער עבור' },
        { field: 'Notes', header: 'הערות' },
      ];

        this.dataService.GetReport(this.selectOptionDDL == null ? "" : this.selectOptionDDL, this.selectedMonth).subscribe((result: any) => {
          this.resultTable = result;
          if (!this.selectOptionDDL && result != null && result.length > 0) {
            this.showFreezeButton = true;
          }
        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהצגת הדוח');
        });
    }
    else{
      this.cols = [
        { field: 'CustomerIdentityNumber', header: 'זיהוי מעסיק' },
        { field: 'CustomerName', header: 'מעסיק' },
        { field: 'MonthsCount', header: 'מספר חודשים' },
        { field: 'FileEmployeeIdCount', header: 'מספר עובדים' },
        { field: 'BankName', header: 'בנק' },
        { field: 'BankBranchName', header: 'סניף' },
        { field: 'AccountNameBank', header: 'חשבון' },
        //{ field: 'UniqueMISPAR_MEZAHE_RESHUMA', header: 'מספר הפרשות' },
        { field: 'SumTnuotLeOvedBeChodesh', header: 'מספר הפרשות' },
        { field: 'CostCalculatedResult', header: 'סכום לגביה' },
        { field: 'CostCalculatedResultIncludeVAT', header: 'סכום לגביה כולל מע"מ' },
      ];
      this.dataService.GetReportAggregated(this.selectOptionDDL == null ? "" : this.selectOptionDDL, this.selectedMonth).subscribe((result: any) => {
        this.resultTable = result;
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בהצגת הדוח');
      });
    }
  }

  CreateExcelSpecialData() {
    try {
      var d = new Date();
      let fileName = 'PaymentReportSpecialExport.' + d.getFullYear().toString() + '.csv';
      this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
      //this.dataService.downloadExcelSpecialData(this.selectOptionDDL == null ? "" : this.selectOptionDDL, this.selectedMonth, this.isGapDataView).subscribe((result: any) => {
      this.dataService.downloadExcelSpecialData(this.resultTable, this.selectedMonth).subscribe((result: any) => {
        window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(result, fileName);
        }
        
        let url = window.URL.createObjectURL(result)
        let link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}`;
        link.click();
        setTimeout(() => {
          this.showMessage('success', '', 'הקובץ נבנה בהצלחה');
        }, 1000);
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ');
      });
    } catch (error) {
      this.showMessage('error', '', 'תקלה בהורדת הקובץ');
    }
  }

  FreezePaymentReport() {
    if (!confirm('האם ברצונך לבצע הקפאת דוח גביה?'))
    {
      return;
    }
    if (this.reportTypeSelected == "רגיל" && this.resultTable && this.resultTable.length > 0 && !this.selectOptionDDL) {
      let sId = this.resultTable[0].SessionId;
      let cnt = this.resultTable.length;
      //this.dataService.FreezePaymentReport(sId, cnt, this.selectedMonth).subscribe((result: any) => {
      this.dataService.FreezePaymentReport(this.resultTable, this.selectedMonth).subscribe((result: any) => {
        this.showMessage('success', '', 'הדוח הוקפא');
        this.monthChanged();
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בהקפאת הדוח');
      });
    }
  }

  GetFrozenPaymentReport() {
    if (this.reportTypeSelected == "רגיל" && this.selectedMonth) {
      this.dataService.GetFrozenPaymentReport(this.selectedMonth).subscribe((result: any) => {
        this.frozenReport = result;
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בשליפת קוח מוקפא');
      });
    }
  }

  ShowFrozenReport() {
    this.isFrozenDataView = true;
    this.isGapDataView = false;

    this.cols = [
      { field: 'CustomerIdentityNumber', header: 'זיהוי מעסיק' },
      { field: 'CustomerName', header: 'מעסיק' },
      { field: 'CHODESH_MASKORET_Formatted', header: 'חודש שכר' },
      { field: 'TypeDescription', header: 'סוג' },
      { field: 'FileEmployeeIdCount', header: 'מספר עובדים' },
      { field: 'BankName', header: 'בנק' },
      { field: 'BankBranchName', header: 'סניף' },
      { field: 'AccountNameBank', header: 'חשבון' },
      //{ field: 'UniqueMISPAR_MEZAHE_RESHUMA', header: 'מספר הפרשות' },
      { field: 'SumTnuotLeOvedBeChodesh', header: 'מספר הפרשות' },
      { field: 'CostCalculatedResult', header: 'סכום לגביה' },
      { field: 'CostCalculatedResultIncludeVAT', header: 'סכום לגביה כולל מע"מ' },
      { field: 'Marker', header: 'סיבת שינוי לסוג חיוב' },
      { field: 'GapForSelectedMonth', header: 'פער עבור' },
      { field: 'Notes', header: 'הערות' },
    ];

    this.resultTable = this.frozenReport;
  }

  ShowGapReport() {
    if (this.reportTypeSelected == "רגיל" && this.selectedMonth && this.frozenReport) {
      this.dataService.GetGapPaymentReport(this.selectedMonth).subscribe((result: any) => {
        this.cols = [
          { field: 'CustomerIdentityNumber', header: 'זיהוי מעסיק' },
          { field: 'CustomerName', header: 'מעסיק' },
          // { field: 'MonthsCount', header: 'מספר חודשים' },
          { field: 'FileEmployeeIdCount', header: 'מספר עובדים' },
          { field: 'BankName', header: 'בנק' },
          { field: 'BankBranchName', header: 'סניף' },
          { field: 'AccountNameBank', header: 'חשבון' },
          { field: 'SumTnuotLeOvedBeChodesh', header: 'מספר הפרשות' },
          { field: 'CostCalculatedResult', header: 'סכום לגביה' },
          { field: 'CostCalculatedResultIncludeVAT', header: 'סכום לגביה כולל מע"מ' },
          { field: 'GapReason', header: 'תאור פער' },
       ];
        this.isGapDataView = true;
        this.isFrozenDataView = false;
        this.gapReport = result;
        this.resultTable = this.gapReport;
      }, (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בשליפת קוח מוקפא');
      });
    }
    
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/payments-report/payments-report.component.ts